export function getChartScale(currency: string) {
  switch (currency) {
    case 'BTC':
      return 4;
    case 'ETH':
      return 3;
    case 'USD':
    case 'GBP':
    case 'EUR':
    case 'MXN':
    case 'NZD':
    case 'AUD':
    case 'RUB':
    case 'TRY':
      return 0;
    default:
      return 4;
  }
}
